<template>
    <!--
        Not a link: `CompaniesView` is retired (#295). This component is currently
        not rendered anywhere — `command-results.vue` renders only OrderResult — but
        resolving a retired route name is what threw MATCHER_NOT_FOUND on /depots.
    -->
    <div
        class="flex h-16 w-full items-center gap-x-4 rounded-md p-2 hover:bg-muval-gray-6 focus:outline-none focus:ring-2 focus:ring-muval-brand"
        @click="context.context.handleClose"
    >
        <SvgIcon
            name="system-companies"
            class="size-10 text-muval-gray-4"
        />
        <div class="flex w-full max-w-32 flex-col">
            <span class="truncate font-medium text-muval-gray-1">{{ data.name }}</span>
            <span class="text-muval-gray-2">{{ $filters.capitalize(data.type) }}</span>
        </div>
    </div>
</template>
<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const context = inject('context');
</script>
